import TaskManagerEditDto from './TaskManagerEditDto';

export class EdtDynamicCheckTaskEditDto extends TaskManagerEditDto {
    constructor() {
        super();

        /** @type {number} */
        this.edtDynamicCheck = null;

        /** @type {number} */
        this.optimizationPipelineLog = null;
    }

    /**
     * @typedef {Object} _EdtDynamicCheckTaskEditDto  Props
     * @property {number} edtDynamicCheck
     * @property {number} optimizationPipelineLog
     *
     * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _EdtDynamicCheckTaskEditDto Props} EdtDynamicCheckTaskEditDto Props
     */
    /**
     *
     * @param {EdtDynamicCheckTaskEditDto Props} props
     * @returns {EdtDynamicCheckTaskEditDto}
     */
    setup(props) {
        super.setup(props);

        this.edtDynamicCheck = props.edtDynamicCheck;
        this.optimizationPipelineLog = props.optimizationPipelineLog;

        return this;
    }
}

export default EdtDynamicCheckTaskEditDto;